import { useCallback, useState } from 'react';
import { useTranslations } from 'next-intl';
import { Checkbox, CheckboxType } from '@nx-frontend/shared/ui/checkbox';

export function ChatbotAddToPagePopup({ localStorageKey }: { localStorageKey: string }) {
  const t = useTranslations('features');
  const [checked, setChecked] = useState(false);
  const onChange = useCallback(
    (value: boolean) => {
      setChecked(value);
      if (value) {
        localStorage.setItem(localStorageKey, 'true');
      } else {
        localStorage.removeItem(localStorageKey);
      }
    },
    [localStorageKey]
  );

  return (
    <div className="flex flex-col gap-2 max-w-[320px] text-sm">
      <span>{t('ai-helper.new_page_will_be_added_to_unsorted')}</span>
      <div className="flex items-center gap-1">
        <Checkbox
          id="allowAiAddToPage"
          checked={checked}
          type={CheckboxType.CHECKBOX}
          onChange={onChange}
          label={t('ai-helper.do_not_show_this_message_again')}
        />
      </div>
    </div>
  );
}
